
function openTab(e) {
  var tabs, headings;
  tabs = document.getElementsByClassName("tabcontent");
  for (let i = 0; i < tabs.length; i++) tabs[i].style.display = "none";
  headings = document.getElementsByClassName("tab-heading");
  for (let i = 0; i < headings.length; i++) headings[i].classList.remove("active");
  var tabId = e + "_tab";
  var tabButton = document.getElementById(tabId);
  var tabContent = document.getElementById(e);
  if (tabButton && tabContent) {
    tabButton.classList.add("active");
    tabContent.style.display = "block";
  }
}

document.addEventListener("DOMContentLoaded", function () {

 const isB2B = document.body.classList.contains('b2b-user');

  const oneTimeTab = document.getElementById("onetime_tab");
  const subTab = document.getElementById("subscription_tab");

  function setMinQty() {
    const qtyInput = document.querySelector(
      'input[id^="Quantity"], #quantity, #quantity-input, input[name="quantity"]'
    );
    if (!qtyInput) return;

    if (isB2B) {
      qtyInput.min = 10;
      if (parseInt(qtyInput.value, 10) < 10) {
        qtyInput.value = 10;
      }
    }
  }

  setTimeout(() => {
    if (oneTimeTab && oneTimeTab.classList.contains("active")) {
      oneTimeTab.click();
    } else if (subTab) {
      subTab.click();
    }

    setMinQty();
  }, 500);

  if (oneTimeTab) {
    oneTimeTab.addEventListener("click", () => setTimeout(setMinQty, 200));
  }
  if (subTab) {
    subTab.addEventListener("click", () => setTimeout(setMinQty, 200));
  }

  $(function () {
    $(".header .stickyBuy__price").text($(".active .tab-price-price").text());

    $("#subscription_tab").on("click", function () {
      const e = $("#sub-frequency").find(":selected").attr("data-sellingplan");
      $('input[name="selling_plan"]').val(e);
      $(".header .stickyBuy__price").text($(".active .tab-price-price").text());
      $(".rc_block__type__autodeliver .rc_label__autodeliver").click();
    });

    $("#onetime_tab").on("click", function () {
      $('input[name="selling_plan"]').val("");
      $(".header .stickyBuy__price").text($(".active .tab-price-price").text());
      $(".rc_block__type__onetime .rc_label__onetime").click();
    });

    $("#sub-frequency").on("change", function () {
      const e = $(this).find(":selected").attr("data-sellingplan");
      $('input[name="selling_plan"]').val(e);
      $(".rc_select__frequency").val($("#sub-frequency").val());
    });

    $(".atc-bt").prop("disabled", true);
    $(".atc-bt").on("click", () => $(".new-atc-bt").click());
    $(".shopify-product-form, .prodMain__priceRow").hide();

    $("#subscription .each-variant, #onetime .each-variant").on("click", function () {
      $(".header .stickyBuy__price").text($(".active .tab-price-price").text());
      var e = $(this).attr("data-variant");
      $('input[name="id"]').val(e);
    });

    setTimeout(function () {
      $('#sub-frequency option[value="30"]').prop("selected", true);
      var e = $("#subscription .each-variant.active").attr("data-variant");
      $("#rc_duplicate_selector").val(e);
      $(".atc-bt").prop("disabled", false);
    }, 4000);
  });
});
